import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import { useAuth } from '../../auth/core/Auth';
import axios from 'axios';

export const RegisterPassive = () => {  
    const intl = useIntl();
    const { logout, currentUser, setCurrentUser } = useAuth();

  return (
    <div className="container">
        <div className='alert alert-danger'>{intl.formatMessage({ id: 'You can not register to the system at this moment. Please check dates from the guide.' })}</div>
    </div>
  );
};